import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import RoutesMap from "../../../../route_control/RouteControl"

export const assetIssueListTodo = createAsyncThunk('assetIssueList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `item_issue`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'block_id': data?.block_id,
                'location_id': data?.location_id,
                'sub_location_id': data?.sub_location_id,
                'staff_id': data?.staff_id,
                'type': data?.type,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetIssueListSlice = createSlice({
    name: 'assetIssueList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(assetIssueListTodo.fulfilled, (state, action) => {
           if (action?.payload?.status == 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status == 401) {
                 showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status == 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }


        });
        builder.addCase(assetIssueListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default assetIssueListSlice.reducer; 